<template>
  <div class="information-card" :style="{ backgroundColor, width }" @click="informationCard(cardData)">
    <a
      class="information-card-title"
      :href="cardData.href"
      target="_blank"
      :style="{
        color: titleFontColor,
        fontSize: titleFontSize,
        fontWeight: titleFontWeight,
      }"
      :title="cardData.cardTitle"
            v-html="processedTitle"
    >
    </a>
    <span style="float: right;">{{ processedTime }}</span>
    <div
      class="information-card-cotent"
      :style="{
        textDecoration: contentTextDecoration,
        color: contentFontColor,
        fontSize: contentFontSize,
        fontWeight: contentFontWeight,
      }"
      v-html="processedContent"
    >
     
    </div>
  </div>
</template>

<script>
import api from "@/services/api"
export default {
  data(){
    return{
       emotionList: {
        1: "正面情绪",
        2: "负面情绪",
        3: "不确定",
      },
    }
  },
  props: {
    cardData: {
      type: Object,
      default: () => {},
    },
    width: {
      type: String,
      default: "90%",
    },
    backgroundColor: {
      type: String,
      default: "#071674",
    },
    // titleTextDecoration: {
    //   type: String,
    //   default: "none",
    // },
    titleFontColor: {
      type: String,
      default: "white",
    },
    titleFontSize: {
      type: String,
      default: "14px",
    },
    titleFontWeight: {
      type: String,
      default: "bold",
    },
    contentTextDecoration: {
      type: String,
      default: "none",
    },
    contentFontColor: {
      type: String,
      default: "white",
    },
    contentFontSize: {
      type: String,
      default: "12px",
    },
    contentFontWeight: {
      type: String,
      default: "normal",
    },
    searchName:{
      type: String,
      default: () => ""
    }
  },
  mounted() {
    // console.log("SearchName",this.searchName)
  },
  watch() {

  },
  methods:{
    changColor(content){
          let replaceString = `<span style="color: #ed4014">${this.searchName}</span>`
           return content.replaceAll(this.searchName, replaceString)
    },
    informationCard(e){
      this.$store.commit('setbarTitle',"事件时间分析")
      this.$store.commit('setlineTitle',"地域事件分析")
      this.$store.commit('setpieTitle',"事件评论分析")
      this.$store.commit('setlegendList',this.emotionList)
      console.log('setlegendList',this.$store.state.echartslegendList);
      let domainId = 1;
      if (this.$store.getters.getSystemType == "海洋信息") {
        domainId = 1;
      } else {
        domainId = 2;
      }
      const param1 = {
        "domain_id": domainId,
        "info_category_id": 3,
        "statistic_kind": 0,
        "region_id": 0,
        "event_id": e.id,
        "if_total": false
      }
      api.region_information.summarize(param1,{params:{name:"事件时间分析"}}).response.then((res)=>res.data).then((res) =>{
          if(res.code == 200) {
            this.$store.commit('setechartsList',res.data)
          }
      })
      const param = {
        "domain_id": domainId,
        "info_category_id": 3,
        "statistic_kind": 2,
        "region_id": 0,
        "event_id": e.id,
        "if_total": false
      }
      api.region_information.summarize(param,{params:{name:"事件时间分析"}}).response.then((res)=>res.data).then((res) =>{
          if(res.code == 200) {
            this.$store.commit('setbarchartsList',res.data)
          }
      })
      const para = {
        "domain_id": domainId,
        "info_category_id": 3,
        "statistic_kind": 1,
        "region_id": 0,
        "event_id": e.id,
        "if_total": false,
         "emotion_map": true
      }
      api.region_information.summarize(para,{params:{name:"事件评论分析"}}).response.then((res)=>res.data).then((res) =>{
          if(res.code == 200) {
            this.$store.commit('setpiechartsList',res.data)
          }
      })
    }
  },
  computed: {
    processedTitle: function () {
      if (this.cardData.cardTitle.length > 15) {
        return  this.changColor(this.cardData.cardTitle.slice(0, 15) + "...")
      } else {
        return this.changColor(this.cardData.cardTitle)
      }
    },
    processedContent: function () {
      if (this.cardData.cardContent.length > 100) {
        return  this.changColor(this.cardData.cardContent.slice(0, 100) + "...")
      } else {
        return  this.changColor(this.cardData.cardContent)
      }
    },
    processedTime: function () {
      return this.cardData.the_time
    },
  },
}
</script>

<style lang="scss">
.information-card {
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  margin: auto;
  margin-top: 10px;
  span {
    color: rgb(223, 198, 165);
  }
  .information-card-title:hover {
    text-decoration: underline;
    color: #fff;
  }
  .information-card-title:visited {
    // text-decoration: underline !important;    // 未生效
    // color: #ac1510ea !important;
  }

  .information-card-cotent {
    // text-indent: 1em;
    margin-top: 5px;
    word-wrap: break-word;
    line-height: 1.5em;
    user-select: none;
  }
}
</style>
